var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.929 16.191l-4.005-4.006c2.22-2.971 1.98-7.213-.716-9.91A7.541 7.541 0 007.842.05c-2.025 0-3.936.79-5.367 2.226A7.543 7.543 0 00.25 7.643c0 2.025.79 3.936 2.225 5.367a7.564 7.564 0 005.367 2.221 7.576 7.576 0 004.541-1.505l4.006 4.005c.213.214.493.319.772.319a1.086 1.086 0 00.768-1.859zM7.842 13.05a5.398 5.398 0 01-3.827-1.584 5.38 5.38 0 01-1.584-3.827 5.38 5.38 0 011.584-3.826 5.38 5.38 0 013.827-1.584 5.38 5.38 0 013.826 1.583 5.418 5.418 0 010 7.65 5.384 5.384 0 01-3.826 1.588z",
    fill: "#009688"
  })));
}
export default __webpack_public_path__ + "search-icon.svg";
export { SvgSearchIcon as ReactComponent };